

const ProjectHover = () => {
    

// 
// 
// 
    return (
        <div className="py-6">
        
            <h1 className="text-2xl font-bold">
                <span className="text-primary ">Projects_Gallery </span>
                <h1 class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400 py-2">Too much good ui more then 100+. </h1>

            </h1>
            <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-4">
               
                    <div className="">
                        <div
                            class="relative  overflow-hidden bg-cover bg-no-repeat"
                            data-te-ripple-init
                            data-te-ripple-color="light">
                            <img
                                src="https://i.ibb.co/6R5JhZH/20230904-120440.jpg"
                                class=""
                                alt="Louvre" />
                            <a target="_blank" href="https://topfrontend02.netlify.app/">
                                <div
                                    class="absolute bottom-0 left-0 right-0 top-0 h-full w-full  bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
                            </a>
                        </div>
                    </div>
                <div className="">
                    <div
                        class="relative  overflow-hidden bg-cover bg-no-repeat"
                        data-te-ripple-init
                        data-te-ripple-color="light">
                        <img
                            src="https://i.ibb.co/Nt3jvds/20230904-124236.jpg"
                            class=""
                            alt="Louvre" />
                        <a target="_blank" href="https://pandami.netlify.app/">
                            <div
                                class="absolute bottom-0 left-0 right-0 top-0 h-full w-full  bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
                        </a>
                    </div>
               </div>


               <div className="">
                    <div
                        class="relative  overflow-hidden bg-cover bg-no-repeat"
                        data-te-ripple-init
                        data-te-ripple-color="light">
                        <img
                            src="https://i.ibb.co/S0Nf3PL/20230904-123939.jpg"
                            class=""

                            alt="Louvre" />
                        <a target="_blank" href="https://taskla-hr.netlify.app/">
                            <div
                                class="absolute bottom-0 left-0 right-0 top-0 h-full w-full  bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
                        </a>
                    </div>
               </div>
               <div className="">
                    <div
                        class="relative  overflow-hidden bg-cover bg-no-repeat"
                        data-te-ripple-init
                        data-te-ripple-color="light">
                        <img
                            src="https://i.ibb.co/g9T1wQW/20230904-123717.jpg"
                            class=""
                            alt="Louvre" />
                        <a target="_blank" href="https://vertual-learning.netlify.app/">
                            <div
                                class="absolute bottom-0 left-0 right-0 top-0 h-full w-full  bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
                        </a>
                    </div>
               </div>
                <div className="">
                    <div
                        class="relative  overflow-hidden bg-cover bg-no-repeat"
                        data-te-ripple-init
                        data-te-ripple-color="light">
                        <img
                            src="https://i.ibb.co/Kzw0WGp/20230904-140221.jpg"
                            class=""
                            alt="Louvre" />
                        <a target="_blank" href="https://calm-paletas-d07c4d.netlify.app/login">
                            <div
                                class="absolute bottom-0 left-0 right-0 top-0 h-full w-full  bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
                        </a>
                    </div>
                </div>
               <div className="">
                    <div
                        class="relative  overflow-hidden bg-cover bg-no-repeat"
                        data-te-ripple-init
                        data-te-ripple-color="light">
                        <img
                            src="https://i.ibb.co/y4rpMDL/20230904-123148.jpg"
                            class=""
                            alt="Louvre" />
                        <a target="_blank" href="https://findteacher.netlify.app/">
                            <div
                                class="absolute bottom-0 left-0 right-0 top-0 h-full w-full  bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
                        </a>
                    </div>
               </div>
             

            </div>
        </div>
    );
};

export default ProjectHover;